<template>
    <section class="edit-permissions page-content">
        <div class="wrap">
            <div class="user-form-box">
                <div class="small-box">
                    <md-checkbox @change="" value="1">Manage Topics of Interest</md-checkbox>
                    <md-checkbox @change="" value="1">Manage Audio and Video content</md-checkbox>
                    <md-checkbox @change="" value="1">Add Notes</md-checkbox>
                    <md-checkbox @change="" value="1">Lock/Unlock Trigger Zones</md-checkbox>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
  data: () => ({})
};
</script>
<style lang="scss" scoped>
.edit-user .wrap {
    margin: 0 !important;
}

.edit-user .edit-permissions .small-box {
    width: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/EditUserPermissions.vue